/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-consumable-bill-item.reducer';

export const PharmacyConsumableBillItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyConsumableBillItemEntity = useAppSelector(state => state.pharmacyConsumableBillItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyConsumableBillItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.detail.title">PharmacyConsumableBillItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.id}</dd>
          <dt>
            <span id="chargedMrp">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.chargedMrp">Charged Mrp</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.chargedMrp}</dd>
          <dt>
            <span id="qty">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.qty">Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.qty}</dd>
          <dt>
            <span id="manufacDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.manufacDate">Manufac Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.manufacDate}</dd>
          <dt>
            <span id="expDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.expDate">Exp Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.expDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.cursor}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.lastupdated}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.discount}</dd>
          <dt>
            <span id="paidAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.paidAmount">Paid Amount</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.paidAmount}</dd>
          <dt>
            <span id="taxCode">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.taxCode">Tax Code</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.taxCode}</dd>
          <dt>
            <span id="cessAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.cessAmount">Cess Amount</Translate>
            </span>
            <UncontrolledTooltip target="cessAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.help.cessAmount" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.cessAmount}</dd>
          <dt>
            <span id="exempted">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.exempted">Exempted</Translate>
            </span>
            <UncontrolledTooltip target="exempted">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.help.exempted" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.exempted ? 'true' : 'false'}</dd>
          <dt>
            <span id="freeQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.freeQty">Free Qty</Translate>
            </span>
            <UncontrolledTooltip target="freeQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.help.freeQty" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.freeQty}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.pharmacyBill">Pharmacy Bill</Translate>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.pharmacyBill ? pharmacyConsumableBillItemEntity.pharmacyBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.pharmacyStock">Pharmacy Stock</Translate>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.pharmacyStock ? pharmacyConsumableBillItemEntity.pharmacyStock.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.uqcType">Uqc Type</Translate>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.uqcType ? pharmacyConsumableBillItemEntity.uqcType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableBillItem.scheme">Scheme</Translate>
          </dt>
          <dd>{pharmacyConsumableBillItemEntity.scheme ? pharmacyConsumableBillItemEntity.scheme.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-consumable-bill-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-consumable-bill-item/${pharmacyConsumableBillItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyConsumableBillItemDetail;
